module.exports = __webpack_public_path__ + "img/analytics-setting.10942bcc.svg";